export class PaginationNewMessages {
    public static readonly PAGE_INFO = 'pagination.page-info';
    public static readonly AMOUNT_TO_DISPLAY = 'pagination.amount-to-display';
    public static readonly FIRST = 'pagination.first';
    public static readonly LAST = 'pagination.last';
}